import React from 'react';
import { View, StyleSheet } from 'react-native';
import Text from './Text';
import { rem } from './values';
const NavigationHeaderTitle = ({ title, children }) => (<View style={styles.titleContainer}>
      <Text Text-18 numberOfLines={1}>
        {title}
      </Text>
      {children}
    </View>);
export default NavigationHeaderTitle;
const styles = StyleSheet.create({
    titleContainer: {
        width: rem(250),
        alignItems: 'center',
    },
});
